<div class="dlmenu" role="menu">
  <div class="dlmenu__label">{{ S['Download workbook'] }}</div>

  <button class="dlmenu__item" role="menuitem" (click)="pick('xlsx')" [attr.aria-label]="S['Excel workbook (.xlsx)']">
    <app-icon name="table" size="18" /> {{ S['Excel workbook (.xlsx)'] }}
  </button>
  <button class="dlmenu__item" role="menuitem" (click)="pick('xls')" [attr.aria-label]="S['Excel 97–2003 (.xls) · values only']">
    <app-icon name="table" size="18" /> {{ S['Excel 97–2003 (.xls) · values only'] }}
  </button>
  <button class="dlmenu__item" role="menuitem" (click)="pick('ods')" [attr.aria-label]="S['OpenDocument (.ods)']">
    <app-icon name="table" size="18" /> {{ S['OpenDocument (.ods)'] }}
  </button>
  <button class="dlmenu__item" role="menuitem" (click)="pick('pdf')" [attr.aria-label]="S['PDF document (.pdf)…']">
    <app-icon name="doc" size="18" /> {{ S['PDF document (.pdf)…'] }}
  </button>

  <div class="dlmenu__sep"></div>

  <button class="dlmenu__item" role="menuitem" (click)="pick('csv')" [attr.aria-label]="S['Current sheet (.csv)']">
    <app-icon name="table" size="18" /> {{ S['Current sheet (.csv)'] }}
  </button>
  <button class="dlmenu__item" role="menuitem" (click)="pick('tsv')" [attr.aria-label]="S['Current sheet (.tsv)']">
    <app-icon name="doc" size="18" /> {{ S['Current sheet (.tsv)'] }}
  </button>

  <div class="dlmenu__sep"></div>

  <button class="dlmenu__item" role="menuitem" (click)="pick('import')" [attr.aria-label]="S['Import workbook…']">
    <app-icon name="upload" size="18" /> {{ S['Import workbook…'] }}
  </button>
  <!-- §11.6.1's "More" menu items; this header has no More menu (B-92), so they sit here. -->
  <button class="dlmenu__item" role="menuitem" (click)="pick('import-csv')" [attr.aria-label]="S['Import CSV as a new sheet…']">
    <app-icon name="table" size="18" /> {{ S['Import CSV as a new sheet…'] }}
  </button>

  @if (share) {
    <div class="dlmenu__sep"></div>

    <button class="dlmenu__item" role="menuitem" (click)="pick('share')" [attr.aria-label]="S['Share via link']">
      <app-icon name="link" size="18" /> {{ S['Share via link'] }}
    </button>
  }

  <div class="dlmenu__sep"></div>

  <button class="dlmenu__item" role="menuitem" (click)="pick('shortcuts')" [attr.aria-label]="S['Keyboard shortcuts']">
    <app-icon name="keyboard" size="18" /> {{ S['Keyboard shortcuts'] }}
  </button>

</div>
